import { useApi } from "@/hooks";
import { Actions, AppContext } from "@Context/common/general/context";
import { GameModes } from "@Enums";
import ScoreFieldTypes from "@Enums/ScoreFieldTypes";
import ScoreTypes from "@Enums/ScoreTypes";
import { Api } from "@Shared/schemas";
import { useCallback, useContext, useEffect, useState } from "react";

export const useRewardUserStats = (rewardId: number, challengeId: number, isOpen: boolean) => {
  const { state, dispatch } = useContext(AppContext);

  const [rewardPercentage, setRewardPercentage] = useState<number | null>(null);
  const [userRank, setUserRank] = useState<number | null>(null);
  const [bestResultIq, setBestResultIq] = useState<number | null>(null);

  const { call: getUserPercentage, data: rewardUserStats } = useApi<typeof Api.Rewards.GetRewardStats>({
    api: Api.Rewards.GetRewardStats,
    request: {
      reward_ids: [rewardId],
      challenge_id: challengeId,
      indistinct: false,
    },
    onSuccess: (data: any) => {
      if (!data) return;

      const response = data.data[0];

      setRewardPercentage(response?.user_percentage ?? 0);
    },
  });

  const getUserResult = useCallback(() => {
    dispatch({
      type: Actions.StatsActions.GetLeaderboard,
      payload: {
        score_field: ScoreFieldTypes.BYB_IQ,
        score_type: ScoreTypes.MAXIMUM,
        challenge_id: Number(challengeId),
        is_completed: true,
        user_id: state.user.id,
        game_mode: GameModes.SCENARIO,
      },
      onSuccess: (data: any) => {
        if (!data || data.length === 0) {
          setUserRank(0);
          return;
        }
        
        const response = data[0];

        setUserRank(response.rank);
        setBestResultIq(response.score);
      },
    });
  }, [challengeId, dispatch, state.user.id]);

  useEffect(() => {
    if (isOpen) return;

    setRewardPercentage(null);
    setUserRank(null);
    setBestResultIq(null);
  }, [isOpen]);

  useEffect(() => {
    if (!rewardId || !challengeId || !isOpen) return;

    getUserPercentage();
    getUserResult();
  }, [rewardId, challengeId, isOpen]);

  return { rewardPercentage, userRank, bestResultIq };
};
